import { CommonModule } from '@angular/common';
import { Component, EnvironmentInjector, EventEmitter, Inject, Input, Output } from '@angular/core';
import { NavigationButtonsComponent } from 'src/app/shared/components/navigation-buttons/navigation-buttons.component';
import { ModalService, ToasterService, ToastType } from '@indice/ng-components';
import { ToasterContainerComponent } from 'src/app/shared/components/toast/toast-container.component';
import { OnboardingExitModalComponent } from '../../onboarding/onboarding-exit-modal/onboarding-exit-modal.component';
import { TranslocoDirective, TranslocoPipe, TranslocoService, } from '@jsverse/transloco';
import { ILoanEligibilityModel } from '../model';
import { DoughnutChartComponent } from "../../../shared/components/loan-calulator/doughnut-chart/doughnut-chart.component";
import { LoanService, LoanValues } from 'src/app/services/loan.service';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, EMPTY, tap } from 'rxjs';
import { PropertyCardItemComponent } from 'src/app/shared/components/property-card-item/property-card-item.component';
import { PortalApiService, PropertyDetails, PropertySummary } from 'src/app/services/portal-api.service';
import { mapInstanceProperties } from 'src/app/shared/utilities/mapInstanceProperties';
import { ExpertsCallbackComponent } from 'src/app/shared/components/experts-callback/experts-callback.component';
import { localizeRoute } from 'src/app/shared/utilities/localizeRoutes';

@Component({
  selector: 'app-loan-eligibility-result',
  standalone: true,
  imports: [CommonModule, NavigationButtonsComponent, TranslocoDirective, DoughnutChartComponent, PropertyCardItemComponent, ExpertsCallbackComponent, TranslocoPipe],
  templateUrl: './loan-eligibility-result.component.html',
  styleUrl: './loan-eligibility-result.component.css'
})
export class LoanEligibilityResultComponent {
  @Input() resultData!: ILoanEligibilityResultModel;
  @Input() formData!: ILoanEligibilityModel
  @Output() resetForm: EventEmitter<void> = new EventEmitter();

  public propertyCardSummaryData: PropertySummary | undefined;

  protected tableIsCollapsed = true;
  protected propertyMortgageCategoryId = '9EEC3373-4411-44C1-82F9-8B12A3C30566'; //this is the category id as provided by nbg
  protected propertyRenovationCategoryId = '300951CE-9CC4-4904-8921-540AD2B6CC20'; //this is the category id as provided by nbg
  protected propertyId = this._activatedRoute.snapshot.queryParams['property'];
  protected latestLoanValues: LoanValues | undefined;
  activeLang = 'el';

  constructor(
    private _modalService: ModalService,
    private _loanService: LoanService,
    private _activatedRoute: ActivatedRoute,
    private _translate: TranslocoService,
    private _router: Router,
    private _portalService: PortalApiService,
    @Inject(ToasterService) private _toastService: ToasterService,
    @Inject(EnvironmentInjector) private envInjector: EnvironmentInjector,
  ) {
    this._loanService.currentLoanValues.pipe(
      tap((t: LoanValues) => {
        this.latestLoanValues = t;
      })
    ).subscribe();

    if (this.propertyId != undefined) {
      this._portalService.getPropertyById(this.propertyId ?? '').pipe(
        catchError((err: any) => {
          this._toastService.show(ToastType.Error, this._translate.translate('Failed to get property'), err.message || 'Unknown error', 10000);

          return EMPTY;
        }),
        tap((t: PropertyDetails) => {
          this.propertyCardSummaryData = mapInstanceProperties(t as PropertyDetails, PropertySummary);
        }),
      ).subscribe();
    }
    this._translate.langChanges$.subscribe(lang => {
      this.activeLang = lang;
    })
  }

  protected onNextClick(): void {
    const params = {
      property: this.propertyId,
      loanAmount: this.latestLoanValues?.loanCalculatorValues.loanAmount,
      loanDuration: this.latestLoanValues?.loanCalculatorValues.loanDuration,
      loanFixedDuration: this.latestLoanValues?.loanCalculatorValues.loanFixedDuration
    };

    this._router.navigate([localizeRoute('/loan-application', this.envInjector)], {
      queryParams: params,
      queryParamsHandling: 'merge'
    });
  }

  protected onPrevClick(): void {
    const propertyId = this._activatedRoute.snapshot.queryParams["property"];
    let path = '/properties'
    if (propertyId) {
      path += `/${propertyId}`
    }

    this._router.navigate([localizeRoute(path, this.envInjector)]);
  }
  protected onCalculateAgain(): void {
    this.resetForm.emit();
  }

  toggleCollapse(event: MouseEvent) {
    this.tableIsCollapsed = !this.tableIsCollapsed;
  }
  protected openModalComponent(): void {
    const exitModal = this._modalService.show(OnboardingExitModalComponent, {
      animated: true,
      keyboard: true,
      class: 'h-dvh md:h-auto',
    });
    exitModal.onHidden?.subscribe((response: any) => {

    });
  }

  goToLoanApplication() {
    this._router.navigate([localizeRoute('/loan-application', this.envInjector)], {
      queryParams: this._activatedRoute.snapshot.queryParams,
      queryParamsHandling: 'merge'
    })
  }
}

export interface ILoanEligibilityResultModel {
  isEligible: boolean,

}
